// extracted by mini-css-extract-plugin
module.exports = {"root":"PermissionsSwitch_root__2YSwO","thumb":"PermissionsSwitch_thumb__ibweo","checked":"PermissionsSwitch_checked__126qx"};